import { render, staticRenderFns } from "./OverviewLeaseDetails.vue?vue&type=template&id=6b028f64&scoped=true&"
import script from "./OverviewLeaseDetails.vue?vue&type=script&lang=js&"
export * from "./OverviewLeaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./OverviewLeaseDetails.vue?vue&type=style&index=0&id=6b028f64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b028f64",
  null
  
)

export default component.exports